import { ticketRemoved } from 'features/virtual/components/virtualTicket/virtualTicketSlice';
import { useAppDispatch } from 'lib/centralStore';
import styles from './VirtualTicketRemoveAllItems.module.scss';

export type VirtualTicketRemoveAllItemsProps = {
  label: string;
};

export const VirtualTicketRemoveAllItems = ({ label }: VirtualTicketRemoveAllItemsProps) => {
  const dispatch = useAppDispatch();
  return (
    <button type="button" className={styles.cancelBtn} onClick={() => dispatch(ticketRemoved())}>
      {label}
    </button>
  );
};
